import type { OrderLineDto } from '../../../../../../generated-api';
import { useLocation } from '../../../../../context/LocationContext';
import { rightPrice } from '../../../../../hooks/useTotalPrice';
import { useCheckout } from '../../../../../context/CheckoutContext';
import { useCartStore } from '../../../../../context/cart/CartStore';
import { useActiveDigitalBill } from '../../../../../context/DigitalBillStore';

interface PriceProps {
  orderLine: OrderLineDto;
}

const Price = (props: PriceProps) => {
  const { orderLine } = props;
  const appliedDiscount = useCartStore((state) => state.appliedDiscount);

  const activeDigitalBill = useActiveDigitalBill();
  const { vatType } = useCheckout();

  const { formatCurrency } = useLocation();

  const isDiscounted = appliedDiscount?.productIds.includes(orderLine.itemVariantId);
  const price = rightPrice(vatType, orderLine.totalPrice, orderLine.totalTakeawayPrice);

  if (!isDiscounted || !appliedDiscount || activeDigitalBill !== undefined) {
    return <div className="text-sm ml-auto">{formatCurrency(price)}</div>;
  }

  const discountedPrice = price - (price * appliedDiscount.amount) / 100;

  return (
    <div className="ml-auto flex flex-col">
      <div className="text-xs line-through self-end  text-grey-dark">{formatCurrency(price)}</div>
      <div className="text-sm">{formatCurrency(discountedPrice)}</div>
    </div>
  );
};

export default Price;
